/*!
 * (C) Larva.io http://larva.io - Seee LICENSE.md
 */
import { r as registerInstance, c as createEvent, h, H as Host, g as getElement } from './index-ef0fa435.js';
import { r as renderHiddenInput } from './helpers-4516ecbe.js';
import { c as createColorClasses } from './theme-d6db8abf.js';
import { createGesture } from './index-46735fee.js';

const toggleCss = "slot-fb[hidden],slot[hidden]{display:initial !important}:host{-webkit-box-sizing:content-box !important;box-sizing:content-box !important;display:inline-block;contain:content;cursor:pointer;-ms-touch-action:none;touch-action:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;z-index:2;width:3rem;height:1.7rem}:host(:focus){outline:none}:host(.lar-toggle-disabled){pointer-events:none;opacity:0.2}input{left:0;top:0;margin:0;position:absolute;width:100%;height:100%;border:0;background:transparent;cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none;outline:none;pointer-events:none}.lar-toggle-icon{border-radius:0.85rem;-webkit-box-sizing:border-box;box-sizing:border-box;display:block;position:relative;width:100%;height:100%;-webkit-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0);-webkit-transition:background-color 300ms;transition:background-color 300ms;background-color:transparent;overflow:hidden;pointer-events:none}.lar-toggle-inner{margin:0.0625rem;border-radius:0.85rem;width:1.45rem;height:1.45rem;-webkit-transition:width 120ms ease-in-out 80ms, left 110ms ease-in-out 80ms, right 110ms ease-in-out 80ms, -webkit-transform 300ms;transition:width 120ms ease-in-out 80ms, left 110ms ease-in-out 80ms, right 110ms ease-in-out 80ms, -webkit-transform 300ms;transition:transform 300ms, width 120ms ease-in-out 80ms, left 110ms ease-in-out 80ms, right 110ms ease-in-out 80ms;transition:transform 300ms, width 120ms ease-in-out 80ms, left 110ms ease-in-out 80ms, right 110ms ease-in-out 80ms, -webkit-transform 300ms;will-change:transform}:host(.lar-toggle-checked) .lar-toggle-icon::before{-webkit-transform:scale3d(0, 0, 0);transform:scale3d(0, 0, 0)}:host(.lar-toggle-checked) .lar-toggle-inner{-webkit-transform:translate3d(1.3rem, 0, 0);transform:translate3d(1.3rem, 0, 0)}:host(.lar-color-primary) .lar-toggle-inner,:host(.lar-color-primary.toggle-checked) .lar-toggle-icon{background:var(--lar-color-primary, #780bb7) !important}:host(.lar-color-primary.toggle-checked) .lar-toggle-inner{background:var(--lar-color-primary-contrast, #fff) !important}:host(.lar-color-primary) .lar-toggle-icon{border:0.0625rem solid var(--lar-color-primary, #780bb7)}:host(.lar-color-secondary) .lar-toggle-inner,:host(.lar-color-secondary.toggle-checked) .lar-toggle-icon{background:var(--lar-color-secondary, #7fb800) !important}:host(.lar-color-secondary.toggle-checked) .lar-toggle-inner{background:var(--lar-color-secondary-contrast, #fff) !important}:host(.lar-color-secondary) .lar-toggle-icon{border:0.0625rem solid var(--lar-color-secondary, #7fb800)}:host(.lar-color-tertiary) .lar-toggle-inner,:host(.lar-color-tertiary.toggle-checked) .lar-toggle-icon{background:var(--lar-color-tertiary, #00a6ed) !important}:host(.lar-color-tertiary.toggle-checked) .lar-toggle-inner{background:var(--lar-color-tertiary-contrast, #fff) !important}:host(.lar-color-tertiary) .lar-toggle-icon{border:0.0625rem solid var(--lar-color-tertiary, #00a6ed)}:host(.lar-color-success) .lar-toggle-inner,:host(.lar-color-success.toggle-checked) .lar-toggle-icon{background:var(--lar-color-success, #7fb800) !important}:host(.lar-color-success.toggle-checked) .lar-toggle-inner{background:var(--lar-color-success-contrast, #fff) !important}:host(.lar-color-success) .lar-toggle-icon{border:0.0625rem solid var(--lar-color-success, #7fb800)}:host(.lar-color-warning) .lar-toggle-inner,:host(.lar-color-warning.toggle-checked) .lar-toggle-icon{background:var(--lar-color-warning, #ffb400) !important}:host(.lar-color-warning.toggle-checked) .lar-toggle-inner{background:var(--lar-color-warning-contrast, #fff) !important}:host(.lar-color-warning) .lar-toggle-icon{border:0.0625rem solid var(--lar-color-warning, #ffb400)}:host(.lar-color-danger) .lar-toggle-inner,:host(.lar-color-danger.toggle-checked) .lar-toggle-icon{background:var(--lar-color-danger, #f6511d) !important}:host(.lar-color-danger.toggle-checked) .lar-toggle-inner{background:var(--lar-color-danger-contrast, #fff) !important}:host(.lar-color-danger) .lar-toggle-icon{border:0.0625rem solid var(--lar-color-danger, #f6511d)}:host(.lar-color-light) .lar-toggle-inner,:host(.lar-color-light.toggle-checked) .lar-toggle-icon{background:var(--lar-color-light, #f4f5f8) !important}:host(.lar-color-light.toggle-checked) .lar-toggle-inner{background:var(--lar-color-light-contrast, #000) !important}:host(.lar-color-light) .lar-toggle-icon{border:0.0625rem solid var(--lar-color-light, #f4f5f8)}:host(.lar-color-medium) .lar-toggle-inner,:host(.lar-color-medium.toggle-checked) .lar-toggle-icon{background:var(--lar-color-medium, #d6d6d6) !important}:host(.lar-color-medium.toggle-checked) .lar-toggle-inner{background:var(--lar-color-medium-contrast, #000) !important}:host(.lar-color-medium) .lar-toggle-icon{border:0.0625rem solid var(--lar-color-medium, #d6d6d6)}:host(.lar-color-dark) .lar-toggle-inner,:host(.lar-color-dark.toggle-checked) .lar-toggle-icon{background:var(--lar-color-dark, #222428) !important}:host(.lar-color-dark.toggle-checked) .lar-toggle-inner{background:var(--lar-color-dark-contrast, #fff) !important}:host(.lar-color-dark) .lar-toggle-icon{border:0.0625rem solid var(--lar-color-dark, #222428)}";

const Toggle = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.larchange = createEvent(this, "larchange", 7);
    this.larfocus = createEvent(this, "larfocus", 7);
    this.larblur = createEvent(this, "larblur", 7);
    this.inputId = `lar-tg-${toggleIds++}`;
    this.pivotX = 0;
    this.onChange = (event) => {
      this.checked = !this.checked;
      event.stopPropagation();
      event.preventDefault();
    };
    this.onKeyUp = () => {
      this.keyFocus = true;
    };
    this.onFocus = (event) => {
      this.larfocus.emit();
      event.stopPropagation();
      event.preventDefault();
    };
    this.onBlur = (event) => {
      this.keyFocus = false;
      this.larblur.emit();
      event.stopPropagation();
      event.preventDefault();
    };
    this.activated = false;
    this.keyFocus = false;
    this.color = undefined;
    this.name = this.inputId;
    this.checked = false;
    this.disabled = false;
    this.value = 'on';
  }
  checkedChanged(isChecked) {
    this.larchange.emit({
      checked: isChecked,
      value: this.value
    });
  }
  async disabledChanged() {
    var _a;
    try {
      (_a = this.gesture) === null || _a === void 0 ? void 0 : _a.enable(!Boolean(this.disabled));
    }
    catch (err) {
      console.error(err);
    }
  }
  async componentDidLoad() {
    try {
      this.gesture = createGesture({
        el: this.el,
        gestureName: 'toggle',
        gesturePriority: 100,
        threshold: 0,
        onStart: ev => this.onStart(ev),
        onMove: ev => this.onMove(ev),
        onEnd: ev => this.onEnd(ev),
      });
      this.disabledChanged();
    }
    catch (err) {
      console.error(err);
    }
  }
  onStart(detail) {
    var _a, _b;
    this.pivotX = detail.currentX;
    this.activated = true;
    // touch-action does not work in iOS
    (_a = detail.event) === null || _a === void 0 ? void 0 : _a.preventDefault();
    (_b = detail.event) === null || _b === void 0 ? void 0 : _b.stopPropagation();
    return true;
  }
  onMove(detail) {
    var _a, _b;
    const currentX = detail.currentX;
    if (shouldToggle(this.checked, currentX - this.pivotX, -5)) {
      this.checked = !this.checked;
      this.pivotX = currentX;
    }
    (_a = detail.event) === null || _a === void 0 ? void 0 : _a.preventDefault();
    (_b = detail.event) === null || _b === void 0 ? void 0 : _b.stopPropagation();
  }
  onEnd(detail) {
    var _a, _b;
    const delta = detail.currentX - this.pivotX;
    if (shouldToggle(this.checked, delta, 0)) {
      this.checked = !this.checked;
    }
    this.activated = false;
    (_a = detail.event) === null || _a === void 0 ? void 0 : _a.preventDefault();
    (_b = detail.event) === null || _b === void 0 ? void 0 : _b.stopPropagation();
  }
  getValue() {
    return this.value || '';
  }
  render() {
    const value = this.getValue();
    renderHiddenInput(this.el, this.name, (this.checked ? value : ''), this.disabled);
    return (h(Host, { class: Object.assign(Object.assign({}, createColorClasses(this.color)), { 'lar-toggle-activated': this.activated, 'lar-toggle-checked': this.checked, 'lar-toggle-disabled': this.disabled, 'lar-toggle-key': this.keyFocus }) }, h("div", { class: "lar-toggle-icon" }, h("div", { class: "lar-toggle-inner" })), h("input", { type: "checkbox", onChange: this.onChange, onFocus: this.onFocus, onBlur: this.onBlur, onKeyUp: this.onKeyUp, checked: this.checked, id: this.inputId, name: this.name, value: value, disabled: this.disabled }), h("slot", null)));
  }
  get el() { return getElement(this); }
  static get watchers() { return {
    "checked": ["checkedChanged"],
    "disabled": ["disabledChanged"]
  }; }
};
function shouldToggle(checked, deltaX, margin) {
  if (checked) {
    return (margin >= deltaX);
  }
  else {
    return (-margin <= deltaX);
  }
}
let toggleIds = 0;
Toggle.style = toggleCss;

export { Toggle as lar_toggle };

//# sourceMappingURL=lar-toggle.entry.js.map